import * as React from 'react';

import Pill from './Pill';

interface OwnProps<T> {
	items: T[];
	labelKey?: string;
	colorKey?: string;
	emptyLabel: string;
	renderItem?: (item: T) => React.JSX.Element | string;
}

type Props<T> = OwnProps<T>;

function PillsList<T,>(props: React.PropsWithChildren<Props<T>>) {
	const {
		items,
		labelKey,
		colorKey,
		emptyLabel,
		renderItem,
	} = props;

	return (
		<div className="pills pills--non-padded">
			{!!items.length && items.map((_item: T, _index: number) =>
				<Pill
					color={colorKey && _item[colorKey]}
					index={_index}
					isLocked={true}
					item={_item}
					key={`pill#${_index}`}
					labelKey={labelKey}
					renderItem={renderItem}
				/>
			)}
			{!items.length &&
				<div className="pills__empty">{emptyLabel}</div>
			}
		</div>
	);
}

export default React.memo(PillsList) as typeof PillsList;
